import { Controller } from "@hotwired/stimulus"

// Automatically submits a form when inputs change, with optional debounce
// Usage:
//   <form data-controller="auto-submit" data-auto-submit-debounce-value="300">
//     <input type="text" data-action="input->auto-submit#submit">
//     <select data-action="change->auto-submit#submitNow">
//   </form>
//
// Values:
//   debounce: milliseconds to wait before submitting (default: 300)
//
// Actions:
//   submit: debounced submit (for text inputs)
//   submitNow: immediate submit (for selects, checkboxes, etc.)
export default class extends Controller {
  static values = {
    debounce: { type: Number, default: 300 },
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  get form() {
    if (this.element?.form){
      return this.element.form
    } else {
      return this.element.closest("form")
    }
  }

  // Submit with debounce (for text inputs)
  submit() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.form?.requestSubmit()
    }, this.debounceValue)
  }

  // Submit immediately (for selects, checkboxes, etc.)
  submitNow() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.form?.requestSubmit()
  }
}
